module.exports = __webpack_public_path__ + "img/m_f_insta.05fcc339.png";